import Registry from '../../../global/Registry';
import EntityId from '../../../../foundation/domain/EntityId';
import Lesson from '../domain/aggregates/lesson/Lesson';
import User from '../../users/domain/aggregates/user/User';
import Exercise from '../domain/aggregates/exercise/Exercise';
import Api from '../../../../foundation/api/Api';
import ExerciseResult from '../domain/aggregates/exerciseResult/ExerciseResult';

export default class ExerciseResultApi extends Api<ExerciseResult> {

	private static instance?: ExerciseResultApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().exerciseResultRepository);
	}

	public async getAllByUserIdAndLessonId (userId: EntityId<User>, lessonId: EntityId<Lesson>) {
		return await this.getList(['/api/exercise-results?userId=', userId, '&lessonId=', lessonId]);
	}

	public async createExerciseResult (userId: EntityId<User>, exerciseId: EntityId<Exercise>, value: string, correct: boolean) {
		const data = {
			userId: userId.getValue(),
			exerciseId: exerciseId.getValue(),
			value: value,
			correct: correct
		};

		return await this.postOne('/api/exercise-results', data);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/api/ExerciseResultApi.ts